import { Component, input, model, ViewEncapsulation } from '@angular/core';
import { Notification } from '@agilox/common';

@Component({
	selector: 'user-notification-item',
	templateUrl: './user-notification-item.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class UserNotificationItemComponent {
	notification = input<Notification | undefined>();
	isExpanded = model<boolean>(true);

	toggleExpand(): void {
		const isExpanded = this.isExpanded();
		this.isExpanded.set(!isExpanded);
	}
}
